export const palette = {
  bg: "#f6f7fb",
  surface: "#ffffff",
  surfaceTint: "#fbfcff",
  surfaceHover: "#f7faff",
  border: "#e5e7ef",
  borderStrong: "#cfd6e3",
  track: "#eef2f7",
  trackSoft: "#f7f9fc",
  text: "#111827",
  textMuted: "#5f6f7f",
  textDim: "#95a1b2",
  accent: "#2563eb",
  accentSoft: "rgba(37, 99, 235, 0.10)",
  danger: "#dc2626",
  dangerSoft: "rgba(220, 38, 38, 0.10)",
  warn: "#f59e0b",
  warnSoft: "rgba(245, 158, 11, 0.10)",
  ok: "#059669",
  okSoft: "rgba(5, 150, 105, 0.10)",
  newfi: "#7c3aed",
  newfiSoft: "rgba(124, 58, 237, 0.10)",
  idle: "#cbd5e1",
  shadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
  shadowHover: "0 16px 32px rgba(15, 23, 42, 0.10)",
};

export default palette;
